import cx from 'classnames';
import { IStatus } from './model/types/IStatus';
import styles from './status-block.module.scss';

interface IProps {
  label: string;
  status: IStatus;
}

const StatusBlock = ({ label, status }: IProps) => {
  return (
    <div className={cx(styles.statusBlock, styles[`status__${status}`])}>
      {label}
    </div>
  );
};

export default StatusBlock;
